export enum TextTypes {
    HEADING_1 = 'Heading 1',
    HEADING_2 = 'Heading 2',
    HEADING_3 = 'Heading 3',
    HEADING_4 = 'Heading 4',
    HEADING_5 = 'Heading 5',
    HEADING_6 = 'Heading 6',
    PARAGRAPH = 'Paragraph',
    LINK = 'Link',
    SMALL_TEXT = 'Small text',
    BUTTON_DEFAULT = 'Button default',
    BUTTON_SMALL = 'Button small'
}

const textElements = ['span', 'div', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']
export type AllowedTextElements = typeof textElements[number]
